import type { ModerationScannerContent } from '../../content/sections/moderation-scanner.js';

/* Catálogo das regras do scanner de packs (ADR-0370/0376/0450/0482). Cada `rule.id` do
   `moderationConfigDto` (packages/admin-contracts) corresponde a uma regra do engine
   `@planuze/pack-scanner`; no card de Regras o admin só via o id cru. O texto (título amigável +
   o que a regra detecta e por que reprova) vem de `content/sections/moderation-scanner.ts#ruleCatalog`
   — este módulo só resolve `rule.id` → entrada, com fallback gracioso para regras fora do catálogo. */

interface RuleDescription {
  /** Nome amigável da regra (o que ela protege), não o id técnico. */
  readonly title: string;
  /** O que a regra detecta e por que aquilo reprova/exige atenção. */
  readonly description: string;
}

/** Descrição de um `rule.id` no idioma corrente, ou `undefined` se a regra não estiver no
    catálogo (o form faz fallback gracioso mostrando o id cru + "sem descrição"). */
export function describeRule(
  id: string,
  copy: ModerationScannerContent,
): RuleDescription | undefined {
  return copy.ruleCatalog[id];
}
